import './StatusDetailedAnalysisComparisonBars.scss'
import IIncidentOverview from '../../../../../common/interfaces/incidentOverview/IIncidentOverview'
import StatusDetailedAnalysisCompareBar from './statusDetailedAnalysisCompareBar/StatusDetailedAnalysisCompareBar'
import OverviewSection from '../../../../../common/components/overviewSection/OverviewSection'
import IIncidentOverviewPeriod from '../../../../../common/interfaces/incidentOverview/IIncidentOverviewPeriod'
import { useEffect, useState } from 'react'
import ICustomer from '../../../../../common/interfaces/customer/ICustomer'


type ComponentProps = {
  customer:ICustomer
  incidentOverview:null|undefined|IIncidentOverview
  handleActiveUserGuideTopicNameChangeRequest: (request:string) => void
}

const StatusDetailedAnalysisComparisonBars = (props:ComponentProps) => {

  const [periodLatest, setPeriodLatest] = useState<IIncidentOverviewPeriod|undefined>()

  useEffect(() => {

    if (props.incidentOverview?.status?.detailedAnalysis?.userIncidentScores) setPeriodLatest(props.incidentOverview?.status.detailedAnalysis.userIncidentScores.periods[0])
    
  }, [])

  return (

    <OverviewSection 
      handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
      contextID='statusDetailedAnalysisComparisonBars' 
      incidentOverview={props.incidentOverview} 
      headerTitle='Din aktuelle Score i detaljer' 
    >      
      {
        periodLatest &&
        <div id='status-detailed-analysis-comparison-bars' onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('incidentOverviewScore')}>
          <StatusDetailedAnalysisCompareBar customer={props.customer} key={'reactionScore'} handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest} title='Reaktions- og håndteringstid' primaryObjectTitle={periodLatest.comparedUsers[0].title} primaryObjectScore={periodLatest.comparedUsers[0].reactionScore} secondaryObjectTitle={periodLatest.comparedUsers[1].title} secondaryObjectScore={periodLatest.comparedUsers[1].reactionScore}></StatusDetailedAnalysisCompareBar>
          <StatusDetailedAnalysisCompareBar customer={props.customer} key={'quantityScore'} handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest} title='Antallet af hændelser' primaryObjectTitle={periodLatest.comparedUsers[0].title} primaryObjectScore={periodLatest.comparedUsers[0].quantityScore} secondaryObjectTitle={periodLatest.comparedUsers[1].title} secondaryObjectScore={periodLatest.comparedUsers[1].quantityScore}></StatusDetailedAnalysisCompareBar>
          <StatusDetailedAnalysisCompareBar customer={props.customer} key={'severityScore'} handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest} title='Hændelsernes alvorlighedsgrad' primaryObjectTitle={periodLatest.comparedUsers[0].title} primaryObjectScore={periodLatest.comparedUsers[0].severityScore} secondaryObjectTitle={periodLatest.comparedUsers[1].title} secondaryObjectScore={periodLatest.comparedUsers[1].severityScore}></StatusDetailedAnalysisCompareBar>
        </div>
      }
    </OverviewSection>

  )

}


export default StatusDetailedAnalysisComparisonBars